export const users = [
  { login: "admin", password: "admin", isAdmin: true },
  { login: "user", password: "user", isAdmin: false },
];
